import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const SearchBar = ({
  searchTerm,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  selectedStatus,
  onStatusChange,
  selectedSort,
  onSortChange,
  categoryOptions = [],
  totalBadges = 0
}) => {

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    onSearchChange(searchTerm);
  };

  return (
    <div className="bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-xl p-6 mb-6">
      <form onSubmit={handleSearchSubmit} className="space-y-4">
        {/* Search Input */}
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
            <Icon name="Search" size={20} className="text-blue-200" />
          </div>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => onSearchChange(e?.target?.value)}
            placeholder="Search badges by name or description..."
            className="w-full pl-12 pr-4 py-3 bg-white bg-opacity-20 border border-white border-opacity-30 rounded-lg text-white placeholder-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-transparent"
          />
        </div>

        {/* Filters */}
        <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
          {/* Category Filter */}
          <div className="flex items-center space-x-2">
            <label className="text-sm font-medium text-blue-100 whitespace-nowrap">
              Category:
            </label>
            <Select
              value={selectedCategory}
              onChange={(e) => onCategoryChange(e?.target?.value)}
              options={[
                { value: 'all', label: 'All Categories' },
                { value: 'learning', label: 'Learning' },
                { value: 'streak', label: 'Streak' },
                { value: 'mastery', label: 'Mastery' },
                { value: 'special', label: 'Special' },
                ...categoryOptions?.filter(cat => !['learning', 'streak', 'mastery', 'special']?.includes(cat))?.map(cat => ({
                    value: cat,
                    label: cat?.charAt(0)?.toUpperCase() + cat?.slice(1)
                  }))
              ]}
              className="w-40 bg-white bg-opacity-10 border-white border-opacity-30 text-white rounded-lg"
            />
          </div>

          {/* Status Filter */}
          <div className="flex items-center space-x-2">
            <label className="text-sm font-medium text-blue-100 whitespace-nowrap">
              Status:
            </label>
            <Select
              value={selectedStatus}
              onChange={(e) => onStatusChange(e?.target?.value)}
              options={[
                { value: 'all', label: 'All Badges' },
                { value: 'active', label: 'Active Only' },
                { value: 'inactive', label: 'Inactive Only' }
              ]}
              className="w-32 bg-white bg-opacity-10 border-white border-opacity-30 text-white rounded-lg"
            />
          </div>

          {/* Sort Options */}
          <div className="flex items-center space-x-2">
            <label className="text-sm font-medium text-blue-100 whitespace-nowrap">
              Sort by:
            </label>
            <Select
              value={selectedSort}
              onChange={(e) => onSortChange(e?.target?.value)}
              options={[
                { value: 'recently-updated', label: 'Recently Updated' },
                { value: 'newest', label: 'Newest First' },
                { value: 'oldest', label: 'Oldest First' },
                { value: 'title-asc', label: 'Name (A-Z)' },
                { value: 'title-desc', label: 'Name (Z-A)' },
                { value: 'most-assigned', label: 'Most Assigned' },
                { value: 'least-assigned', label: 'Least Assigned' },
                { value: 'points-high', label: 'Highest Points' },
                { value: 'points-low', label: 'Lowest Points' }
              ]}
              className="w-40 bg-white bg-opacity-10 border-white border-opacity-30 text-white rounded-lg"
            />
          </div>
        </div>
      </form>
      {/* Quick Stats */}
      <div className="mt-4 pt-4 border-t border-white border-opacity-20">
        <p className="text-sm text-blue-200">
          {totalBadges > 0 ? (
            <>
              <Icon name="Award" size={16} className="inline mr-1" />
              {totalBadges} total badge{totalBadges !== 1 ? 's' : ''} available
            </>
          ) : (
            'No badges found'
          )}
        </p>
      </div>
    </div>
  );
};

export default SearchBar;